/**
 * Bootstrap: ensure device_id and session_id exist; return full observability context.
 * Call getObservabilityContext() before initFaro() at app entry.
 */

import { getDeviceId } from './device.service';
import { getSessionId } from './session.service';
import { getDeviceMetadata } from './device.service';
import type { ObservabilityContext } from './types';

export function getObservabilityContext(): ObservabilityContext {
  const device_id = getDeviceId();
  const session_id = getSessionId();
  const device_meta = getDeviceMetadata();
  return {
    device_id,
    session_id,
    device_meta,
  };
}
